import { Injectable, Injector } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
import { EstimativaTipo } from '../models/estimativa-tipo.model';

@Injectable({
  providedIn: 'root'
})
export class EstimativaTipoService extends BaseService<EstimativaTipo> {

  constructor(protected injector: Injector) {
    super(`${environment.API_PRICE}/estimativatipo`, injector);
  }
}
